<script setup>
import { ref, watch } from 'vue'
import { useField } from 'vee-validate'
import Services from '../services'

const props = defineProps(['field', 'modelValue'])
const isMultiple = props.field.field_type == 'multifile'
const accept = props.field.choices.replaceAll('\r\n', ',')
const rules = ref({
  required: props.field.required,
})

const { value: model } = useField(() => props.field.clean_name, rules, {
  syncVModel: true,
})

const clearModel = () => {
  model.value = Services.fieldDefaults[props.field.field_type]
}

watch(
  () => model.value,
  (value) => {
    if (
      value instanceof File ||
      (Array.isArray(value) && value[0] instanceof File)
    ) {
      if (props.field.max_file_size)
        rules.value = { ...rules.value, size: props.field.max_file_size * 1024 }

      if (props.field.max_length && isMultiple)
        rules.value = { ...rules.value, max_files: props.field.max_length }
    }
  },
)
</script>

<template>
  <div class="upload-container" :class="{ 'is-active': model }">
    <div class="columns is-vcentered">
      <div class="column is-narrow">
        <b-upload
          v-model="model"
          v-bind="{
            native: true,
            multiple: isMultiple,
            accept,
          }"
          :name="field.clean_name"
        >
          <span
            class="button is-black has-radius-small"
            v-text="
              model
                ? $t(`form.${field.field_type}.reupload`)
                : $t(`form.${field.field_type}.upload`)
            "
          />
        </b-upload>
      </div>

      <div class="column has-text-right filename" v-if="model && !isMultiple">
        {{ model.name }}
      </div>

      <div class="column is-narrow ml-auto" v-if="model">
        <b-button
          icon-left="x"
          type="is-light"
          class="is-square has-radius-small is-size-5"
          @click="clearModel"
        ></b-button>
      </div>
    </div>

    <div class="filename-list" v-if="model && isMultiple">
      <p v-for="file in model" class="filename">{{ file.name }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upload-container {
  padding: 10px;
  background: $grey-light;
  border-radius: $radius-control;
  display: inline-block;

  &.is-active {
    display: block;
  }

  .filename {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: $size-8;
  }

  .filename-list {
    padding: 0 20px 20px;
  }

  .button.is-black {
    &:hover {
      background: $primary;
      color: $primary-invert;
    }
  }
}
</style>
